import type { Attachment } from '@medplum/fhirtypes'
import { Button } from '@seen/ui'
import { IconZoomIn } from '@tabler/icons-react'
import type { JSX } from 'react'
import { AttachmentCardLayout } from '#src/components/attachments/AttachmentCardLayout.tsx'
import { AttachmentPDFModal } from '#src/components/attachments/AttachmentPDFModal.tsx'

interface AttachmentPDFDisplayProps {
  attachment: Attachment
  url: string
  isExpanded: boolean
  onExpandedChange: (expanded: boolean) => void
  onTitleChange?: (title: string) => void
}

export function AttachmentPDFDisplay({
  attachment,
  url,
  isExpanded,
  onExpandedChange,
  onTitleChange,
}: AttachmentPDFDisplayProps): JSX.Element {
  const title = attachment.title || 'PDF Document'

  return (
    <>
      <AttachmentCardLayout
        attachment={attachment}
        title={title}
        icon={<FileIcon />}
        onTitleChange={onTitleChange}
        preview={
          <div className="h-[500px] w-full overflow-auto">
            <iframe
              className="h-full w-full"
              src={`${url}#view=Fit&toolbar=0&navpanes=0&scrollbar=1`}
              title={title}
            />
          </div>
        }
        extraActions={
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onExpandedChange(true)}
            title="Zoom"
          >
            <IconZoomIn className="h-4 w-4" />
          </Button>
        }
      />
      <AttachmentPDFModal
        url={url}
        title={title}
        open={isExpanded}
        onOpenChange={onExpandedChange}
      />
    </>
  )
}

function FileIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 1V6.75C6.75 7.5297 7.34489 8.17045 8.10554 8.24313L8.25 8.25H14V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13V3C2 1.89543 2.89543 1 4 1H6.75ZM8 1L14 7.03022H9C8.44772 7.03022 8 6.5825 8 6.03022V1Z"
      />
    </svg>
  )
}
